/** 타이포그래피 상수 — 아래 값만 수정하면 전체 폰트 크기가 반영됩니다. */
export const TYPOGRAPHY = {
  /** 섹션 제목 (Cover 이름, Invitation 제목, 방명록 등) */
  title: 22,
  /** 부제목·본문 강조 (날짜, 장소, 초대 문구, 캘린더 등) */
  heading: 18,
  /** 일반 본문·버튼·입력 */
  body: 16,
  /** 보조 본문 (작은 버튼 등) */
  bodySmall: 14,
  /** 안내·캡션 */
  caption: 12,
  /** 장식용 큰 텍스트 (캘린더 하트 등) */
  display: 36,
  /** 모달 닫기 등 큰 아이콘 버튼 */
  iconLarge: 26,
  /** 작은 아이콘 버튼 */
  icon: 18,
};
